module.exports = __webpack_public_path__ + "img/742751.0469271b.png";